// Zielpfad eines Vertrags wählen (Lennard 27.10.2026) — Ordner in Dropbox durchklicken wie „Zielpfad angeben"
// in Dokumente verschieben, oder über die Ordnersuche springen. Liest nur (browse-ordner / ordner-suche).
import React, { useCallback, useEffect, useState } from "react";
import { API_BASE } from "../../api/config";

const START = "/Holthey Immobilien/Objekte";
const zApi = (pfad) => fetch(`${API_BASE}/zuordnen/api${pfad}`).then(async (r) => {
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || `HTTP ${r.status}`);
  return d;
});

export default function OrdnerWahl({ wert, onWahl, onClose }) {
  const [pfad, setPfad] = useState(wert || START);
  const [ordner, setOrdner] = useState([]);
  const [laedt, setLaedt] = useState(false);
  const [fehler, setFehler] = useState("");
  const [suche, setSuche] = useState("");
  const [treffer, setTreffer] = useState([]);

  const oeffnen = useCallback(async (p) => {
    setLaedt(true); setFehler("");
    try {
      const d = await zApi(`/verschieben/browse-ordner?path=${encodeURIComponent(p)}`);
      setOrdner((d.ordner || []).filter((o) => o.is_folder)); setPfad(p);
    } catch (e) { setFehler(String(e.message || e)); }
    setLaedt(false);
  }, []);
  useEffect(() => { oeffnen(wert || START); }, [oeffnen, wert]);

  useEffect(() => {
    const q = suche.trim();
    if (q.length < 2) { setTreffer([]); return undefined; }
    const t = setTimeout(() => zApi(`/verschieben/ordner-suche?q=${encodeURIComponent(q)}`)
      .then((d) => setTreffer(d.treffer || [])).catch(() => setTreffer([])), 300);
    return () => clearTimeout(t);
  }, [suche]);

  const teile = pfad.split("/").filter(Boolean);
  return (
    <div className="sd-overlay sd-ordner-overlay" onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="sd-dialog sd-ordner" onClick={(e) => e.stopPropagation()}>
        <div className="sd-kopf">
          <h3>Zielpfad wählen</h3>
          <button className="sd-btn" onClick={onClose}>✕</button>
        </div>
        <div className="sd-ordner-pfad">
          {teile.map((t, i) => (
            <React.Fragment key={i}>
              <span className="sd-ordner-teil" onClick={() => oeffnen("/" + teile.slice(0, i + 1).join("/"))}>{t}</span>
              {i < teile.length - 1 && <span className="sd-klein"> / </span>}
            </React.Fragment>
          ))}
        </div>
        <input className="sd-in" style={{ width: "100%", margin: "8px 0" }} placeholder="Ordner suchen (Name, Kreditor, Objekt …)"
          value={suche} onChange={(e) => setSuche(e.target.value)} />
        <div className="sd-ordner-liste">
          {suche.trim().length >= 2 ? (
            treffer.length ? treffer.map((t) => (
              <div key={t.path} className="sd-ordner-zeile" onClick={() => { setSuche(""); oeffnen(t.path); }} title={t.path}>
                📁 {t.name} <span className="sd-klein">{t.path}</span>
              </div>
            )) : <div className="sd-klein">Keine Treffer.</div>
          ) : (
            <>
              {teile.length > 1 && (
                <div className="sd-ordner-zeile" onClick={() => oeffnen("/" + teile.slice(0, -1).join("/"))}>⬆ eine Ebene hoch</div>
              )}
              {laedt && <div className="sd-klein">Lade…</div>}
              {!laedt && ordner.map((o) => (
                <div key={o.path} className="sd-ordner-zeile" onClick={() => oeffnen(o.path)}>📁 {o.name}</div>
              ))}
              {!laedt && !ordner.length && !fehler && <div className="sd-klein">Keine Unterordner.</div>}
            </>
          )}
          {fehler && <div className="sd-fehler">{fehler}</div>}
        </div>
        <div className="sd-leiste" style={{ justifyContent: "flex-end", marginTop: 10 }}>
          {wert && <button className="sd-btn" onClick={() => onWahl("")}>Zielpfad entfernen</button>}
          <button className="sd-btn" onClick={onClose}>Abbrechen</button>
          <button className="sd-btn primary sd-ordner-uebernehmen" disabled={laedt || !!fehler} onClick={() => onWahl(pfad)}>
            Diesen Ordner übernehmen
          </button>
        </div>
      </div>
    </div>
  );
}
